const styles = ':host{align-items:center;display:flex;flex-direction:column;justify-content:center}.modal{border-radius:.5rem;margin:1.5rem;max-height:75vh;max-width:31.5rem;opacity:0;transform:scale(90%);transition:transform var(--skapa-modal-transition-duration) var(--skapa-modal-transition-function);transition-property:transform,opacity}:host([open]) .modal.visible{opacity:1;transform:scale(100%)}slot[name=header]{--skapa-modal-header-padding:0.5rem 0.5rem 0 0.5rem;min-height:2rem}div.modal-body{overflow:unset}slot[name=title]:not([skapa-empty]){margin-bottom:.75rem}@media (orientation:landscape){.modal{max-height:unset}}@media (min-width:37.5em){.modal-body{font-size:1rem;line-height:1.625}.modal-body::slotted(:not(:first-child)){margin-top:1rem}slot[name=title]:not([skapa-empty]){margin-bottom:1rem}}';
import { ModalAbstract } from "./ModalAbstract.js";
import { SlotTools } from "@ingka/webc-tools";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <div class="modal" part="wrapper">
      <slot name="header"></slot>
      <div class="modal-body"><slot name="title"></slot></div>
      <slot class="modal-body"></slot>
      <slot name="footer"></slot>
    </div>
  `;
  return { main: template };
}
class Prompt extends ModalAbstract {
  constructor() {
    super();
    this.handleSlotChange = (event) => {
      SlotTools.slotChange(event);
      if (event.target) {
        const target = event.target;
        if (target.name === "footer") this.updateAssignedFooter();
      }
    };
    this.updateAssignedFooter = () => {
      const footer = this.querySelector(this.getPrefixedTagName("modal-footer"));
      if (footer) footer.setAttribute("small", "");
    };
    const templates = this.getTemplates(generateTemplate);
    this.shadowRoot.append(templates.main.content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    Array.from(this.shadowRoot.querySelectorAll("slot")).map(
      SlotTools.checkSlot
    );
    this.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    this.updateAssignedFooter();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
  }
}
Prompt.skapaTagName = "prompt";
Prompt.skapaDependencies = [...ModalAbstract.skapaDependencies];
export {
  Prompt
};
